// Gemeinsame Auswahl-Logik für "welches Auto zeigt die Startseiten-Karte".
// Wird client-seitig (useFirstCompletedCar) UND server-seitig (layout.js,
// SSR-initialCarData) benutzt, damit beide garantiert dasselbe Auto wählen.
// Muss deshalb pur bleiben: keine Firebase-Imports, keine Browser-APIs.

export const toMs = (ts) => {
  if (!ts) return 0;
  if (typeof ts.toMillis === "function") return ts.toMillis();
  if (ts instanceof Date) return ts.getTime();
  if (typeof ts === "number") return ts;
  if (typeof ts === "object") {
    // Client-SDK: {seconds}, Admin-SDK nach JSON-Serialisierung: {_seconds}
    const seconds = ts.seconds ?? ts._seconds;
    if (typeof seconds === "number") return seconds * 1000;
  }
  if (typeof ts === "string") {
    const parsed = Date.parse(ts);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

// entries: [{ id, data }] – gibt {id, ...data} des gewählten Autos zurück (oder null).
export const selectFirstCompletedCar = (entries) => {
  let latestEntry = null;
  let latestStamp = 0;
  let bestCompletedEntry = null;
  let bestCompletedStamp = 0;

  // Stabil nach Doc-ID sortieren: Server (getAll, fins-Reihenfolge) und Client
  // (in-Query, ID-sortiert) iterieren sonst unterschiedlich und würden bei
  // Timestamp-Gleichstand verschiedene Autos wählen (sichtbarer Karten-Swap
  // nach dem stillen Refresh).
  const sorted = [...(entries || [])].sort((a, b) =>
    String(a?.id ?? "").localeCompare(String(b?.id ?? "")),
  );

  sorted.forEach((entry) => {
    const data = entry?.data || {};
    const createdMs = toMs(data?.createdAt) || toMs(data?.valuationCreatedAt);

    if (createdMs > latestStamp) {
      latestStamp = createdMs;
      latestEntry = entry;
    }

    if (data?.isCompleted === true) {
      const valuationMs =
        toMs(data?.valuationCreatedAt) || toMs(data?.createdAt);
      if (valuationMs > bestCompletedStamp) {
        bestCompletedStamp = valuationMs;
        bestCompletedEntry = entry;
      }
    }
  });

  const latestData = latestEntry?.data || null;
  const latestIsAB =
    latestData?.ab?.priceCalculationAutomated === true ||
    latestData?.priceCalculationAutomated === true;
  const latestIsSelfValuation = latestData?.ab?.selfValuation === true;

  const chosen =
    latestIsAB || latestIsSelfValuation ? latestEntry : bestCompletedEntry;

  return chosen ? { id: chosen.id, ...chosen.data } : null;
};
